<template>
    <div class="productChainBox">
        <!-- <div class="chainTitle">产业链</div> -->
        <div class="box">
            <div id="mainChain" class="main" style="width:100%; height:100%;"></div>
        </div>

    </div>
</template>

<script>
  import {mapState} from 'vuex'
  import ssUtil from '@/utils/SStorage'
  export default {
    name: 'productChain',
    data() {
        return {
            productChain: {},
            isClickFlag : false,
            paramsInfo:{},
        }
    },
    computed: {...mapState(['productShowInfo','indexSearchInfo','productRouterInfo','colorArr'])},
    created(){
        this.paramsInfo = this.productRouterInfo
        this.getProductChain(this.productRouterInfo);
    },
    methods: {
        //获取产业链
        getProductChain( params ){
            this.$store.dispatch('getProductChain',{productCode:params.productCode}).then( res => {
                if( res.status == 200 ){
                    this.productChain = res.data.data
                    this.showGraph();
                }
            })
        },
        //展示关系图
        showGraph(){
            let that = this,elList=[],myChart = [],data = [],links = [];
            // let color = ['#8f726c','#c26b71','#cf9087','#c18b67','#6a878d','#949784','#d5b57a','#889a80','#699f8f','#8797a7','#a37f7f','#cac1d4','#ededeb','#d4d5cd','#b7b1a5','#d8a09f','#dbdbd9','#abb7a1','#c1cbd7','#8696a7','#9ca8b8','#7a7281','#c9c0d3','#d8caaf','#d3d4cc'];
            this.productChain.baseData.forEach(function( item,index ){
                data.push({
                    value : item.name,
                    name : item.name,
                    // symbolSize : item.level<=4?30+(4-item.level)*10:40,
                    symbolSize : 30,
                    typeFlag : 'product',
                    chainName : item.name,
                    code : item.code,
                    industry: item.industry,
                    itemStyle: {
                        normal: {
                            color: that.colorArr[item.level]
                            // color: color[item.level]
                        }
                    }
                })
            })

            links = this.productChain.relationData
            var option = {
                title: {text: ''},
                tooltip: {
                    show: true,
                    trigger: 'item',
                },
                animation:false,
                animationEasingUpdate: 'quinticInOut',
                series: [
                {
                    type: 'graph',
                    layout: 'force',
                    symbol: 'circle',
                    symbolSize: 30,
                    draggable: true,
                    roam: true,
                    label: {
                        normal: {
                            show: true,
                            fontWeight: 500,
                            fontSize: 16,
                            position:'top',
                            color:'#333',
                        }
                    },
                    force: {
                        // 力引导布局相关的配置项，力引导布局是模拟弹簧电荷模型在每两个节点之间添加一个斥力，每条边的两个节点之间添加一个引力，每次迭代节点会在各个斥力和引力的作用下移动位置，多次迭代后节点会静止在一个受力平衡的位置，达到整个模型的能量最小化。
                        // 力引导布局的结果有良好的对称性和局部聚合性，也比较美观。
                        repulsion: 845, // [ default: 50 ]节点之间的斥力因子(关系对象之间的距离)。支持设置成数组表达斥力的范围，此时不同大小的值会线性映射到不同的斥力。值越大则斥力越大
                        edgeLength: 155 // [ default: 30 ]边的两个节点之间的距离(关系对象连接线两端对象的距离,会根据关系对象值得大小来判断距离的大小)，
                        // 这个距离也会受 repulsion。支持设置成数组表达边长的范围，此时不同大小的值会线性映射到不同的长度。值越小则长度越长。如下示例:
                        // 值最大的边长度会趋向于 10，值最小的边长度会趋向于 50      edgeLength: [10, 50]
                    },
                    edgeSymbol: ['circle', 'arrow'],
                    edgeSymbolSize: [4, 10],
                    data: data,
                    tooltip: {
                        formatter: function(param) {
                            if (param.dataType === 'edge') {
                                return param.data.category;
                            }
                            return param.data.name;
                        },
                        backgroundColor: 'rgba(50,50,50,0.8)'
                    },
                    // edgeLabel: {                // 连接两个关系对象的线上的标签
                    //     normal: {
                    //             show: true,
                    //             textStyle: {
                    //                 fontSize: 16
                    //             },
                    //             formatter: function(param) {        // 标签内容
                    //                 return param.data.category;
                    //             }
                    //         }
                    // },
                    links: links,
                    lineStyle: {
                        normal: {
                            opacity: 0.5,
                            width: 1,
                            curveness: 0
                        }
                    }
                }
                ]
            };
            // 基于准备好的dom，初始化echarts实例
            this.$nextTick(function(){
                myChart = that.$echarts.init( document.getElementById('mainChain'))
                myChart.setOption(option);
                myChart.on('click', function (param) {
                    if(param.data.source&&param.data.target){
                        return;
                    }
                    let params = {
                        type: 'product',
                        name:param.data.chainName,
                        industry:param.data.industry,
                        productCode:param.data.code
                    }
                    that.$store.dispatch('productRouterInfo',params)
                });
            })
        },
        //展示折线图
        showLine(){
            let that = this,elList=[],myChart = [];
            // var myChart = this.$echarts.init(document.getElementById('mainLine'));
            this.indexSearchInfo.forEach(function( item ){
                let xData = [],seriesData = []
                item.seriesDataList.forEach(function(it){
                    xData.push(it.dataTime.split(' ')[0]),
                    seriesData.push(it.dataValue)
                })
                var option = {
                    title: {
                        left: 'center',
                        text: item.seriesName,
                        // subtext: item.securityCode,
                    },
                    tooltip: {
                        trigger: 'axis',
                        formatter: function (params) {
                            params = params[0];
                            return params.value+'<br />'+params.name;
                        },
                        axisPointer: {
                            animation: false
                        }
                    },
                    xAxis: {
                        type: 'category',
                        data: xData
                    },
                    yAxis: {
                        type: 'value',
                        min:'dataMin'
                    },
                    series: [{
                        name:item.seriesName,
                        type:'line',
                        data:seriesData
                    }]
                };
                that.productLineInfo.push(option);
            })
            this.$nextTick(function(){
                elList = document.querySelectorAll('.productAlterBox>ul>li')
                for(var i=0;i< elList.length;i++ ){
                    myChart.push( that.$echarts.init(document.getElementById('mainLine'+i)));
                }
                for(var i=0;i< elList.length;i++ ){
                //   指定图表的配置项和数据
                    myChart[i].setOption(that.productLineInfo[i]);
                }
            })
        }
    },
    mounted() {},
    watch:{
        productRouterInfo:{
            handler(newVla, oldVal) {
                if( this.paramsInfo.name != this.productRouterInfo.name){
                            this.getProductChain(this.productRouterInfo);
                            this.paramsInfo = this.productRouterInfo;
                }
            },
            deep: true
        }
    }
  }
</script>

<style lang="scss" src="../../../sass/productInfo/productChain.scss"></style>



// WEBPACK FOOTER //
// src/components/productInfoComponents/productCom/productChain.vue